__turbopack_context__.v({
  "image": "BitmapIcon-module__N0izba__image",
  "root": "BitmapIcon-module__N0izba__root",
});
